import { isNullOrWhiteSpace } from "./utils";
import {
	ScoredCategoryViewModel,
	WritingAnalysisViewModel,
} from "../features/scoreReport/scoreReportApiSlice";

export function GetTraitFeedback(
	analysis: WritingAnalysisViewModel | undefined,
	trait: ScoredCategoryViewModel | undefined
): string[] {
	if (analysis === undefined || trait === undefined) {
		return [];
	}
	if (trait.isProctorScored) {
		return isNullOrWhiteSpace(trait.feedback) ? [] : [trait.feedback];
	}
	return [
		...(analysis.staticFeedback[trait.id] ?? []),
		...(analysis.targetedFeedback[trait.id] ?? []),
	];
}

export function GetTraitLlmFeedback(
	analysis: WritingAnalysisViewModel | undefined,
	trait: ScoredCategoryViewModel | undefined
): string[] {
	if (
		analysis === undefined ||
		trait === undefined ||
		!analysis.llmFeedback ||
		!analysis.llmFeedback.feedback ||
		!(trait.id in analysis.llmFeedback.feedback)
	) {
		return [];
	}

	return analysis.llmFeedback.feedback[trait.id];
}
